export default __webpack_public_path__ + "static/media/square-1.03ef5115.svg";